import { render, staticRenderFns } from "./NoticeBoard.vue?vue&type=template&id=0e880480&scoped=true"
import script from "./NoticeBoard.vue?vue&type=script&lang=js"
export * from "./NoticeBoard.vue?vue&type=script&lang=js"
import style0 from "./NoticeBoard.vue?vue&type=style&index=0&id=0e880480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e880480",
  null
  
)

export default component.exports